import { DeleteOutlined, InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Col,
    Collapse,
    Form, Input,
    Radio,
    Row,
    Select,
    Table,
    Tabs,
    Tag, Tooltip,
    notification
} from "antd";
import { useEffect, useState } from "react";
import {
    addAndroidTemplateRestriction,
    addTemplateRestriction,
    deleteAndroidTemplateRestriction,
    deleteTemplateRestriction,
    getAndroidTemplateRestriction,
    getTemplateRestriction
} from "../../../axios/api.device";
import { gaEvent } from "../../../withTracker";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentRestriction = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [dataInfo, setDataInfo] = useState<any>({});
    const [formValue, setFormValue] = useState<any>({});
    const [showDict, setShowDict] = useState<any>({});
    const [integerList, setIntegerList] = useState<any>([]);
    const [bundleIdList, setBundleIdList] = useState<Record<string, string[]>>({});

    const [openSystemPreferences, setOpenSystemPreferences] = useState(false);
    const [checkedList, setCheckedList] = useState<any>([]);
    const [checkedList2, setCheckedList2] = useState<any>([]);
    // const [indeterminate, setIndeterminate] = useState(false);
    // const [checkAll, setCheckAll] = useState(false);

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo();
    }, [])
    const getDataInfo = () => {
        if (platform === "IOS" || platform === "macOS") {
            getTemplateRestriction(templateId).then((res) => {
                if (res && res != null) {
                    var defaultSystemPreference: any = {
                        settings: [],
                        preferences: [],
                    };
                    var defaultValue: any = {};
                    var defaultDict: any = {};
                    var defaultList: any = [];
                    var defaultBundleIdList: string[] = [];
                    var defaultBundleIdMap: { [key: string]: string[] } = {}; // 存储Bundle ID映射
                    var count = 0;

                    res.categoricalRestrictions.forEach((rets: any) => {
                        rets.restrictions.forEach((item: any) => {
                            if(item.valueType === 'boolean')
                                defaultValue[item.key] = item.isAllow;
                            else if(item.valueType === 'integer')
                            {
                                defaultValue[item.key] = item.integerValue;
                                defaultList.push(item.key);
                            }
                            if (item.children) {
                                item.children.forEach((chilItem: any) => {
                                    if (chilItem.valueType === 'integer') {
                                        defaultValue[chilItem.key] = chilItem.integerValue;
                                        defaultDict[item.key] = item.isAllow;
                                        defaultList.push(chilItem.key);
                                    } else if (chilItem.valueType === 'stringArray' && chilItem.key === 'allowedCameraRestrictionBundleIDs') {
                                        // 处理字符串数组类型
                                        defaultBundleIdMap[item.key] = chilItem.stringArrayValue || [];
                                        defaultValue[chilItem.key] = chilItem.stringArrayValue || [];
                                        defaultDict[item.key] = item.isAllow;
                                    } else {
                                        defaultValue[chilItem.key] = chilItem.isAllow;
                                    }
                                })
                            }
                        })
                    })

                    res.systemPreferenceKeys.forEach((item: any) => {
                        if (item.isSettings) {
                            defaultSystemPreference["settings"].push(item);
                        } else {
                            defaultSystemPreference["preferences"].push(item);
                        }
                        if (item.isSelected) {
                            count++;
                        }
                    })
                    
                    setCheckedList(defaultSystemPreference["preferences"]);
                    setCheckedList2(defaultSystemPreference["settings"]);
                    setOpenSystemPreferences(res?.isSystemPreference);
                    setFormValue(defaultValue);
                    setDataInfo(res);
                    setShowTable(res.isAdd ? 2 : 1);
                    setShowDict(defaultDict);
                    setIntegerList(defaultList)
                    setBundleIdList(defaultBundleIdMap);
                } else {
                    setShowTable(1)
                }

            })
        } else {
            getAndroidTemplateRestriction(templateId).then(res => {
                if (res && res != null) {
                    var defaultValue: any = {}
                    res.categoricalRestrictions.forEach((item: any) => {
                        item.restrictions.forEach((restriction: any) => {
                            if (restriction.selectedOption) {
                                defaultValue[restriction.key] = restriction.selectedOption;
                            }else{
                                defaultValue[restriction.key] = restriction.options[0];
                            }
                        })
                    })
                    setFormValue(defaultValue);
                    setDataInfo(res)
                    setShowTable(res.isAdd ? 2 : 1);
                } else {
                    setShowTable(1)
                }

            })
        }
    }


    const addBundleId = (parentKey: string) => {
        const currentList = bundleIdList[parentKey] || [];
        setBundleIdList({
            ...bundleIdList,
            [parentKey]: [...currentList, '']
        });
    }

    // 新增：删除Bundle ID
    const removeBundleId = (parentKey: string, index: number) => {
        const currentList = bundleIdList[parentKey] || [];
        const newList = currentList.filter((_: any, i: any) => i !== index);
        setBundleIdList({
            ...bundleIdList,
            [parentKey]: newList
        });
    }

    // 新增：更新Bundle ID
    const updateBundleId = (parentKey: string, index: number, value: string) => {
        const currentList = bundleIdList[parentKey] || [];
        const newList = [...currentList];
        newList[index] = value;
        setBundleIdList({
            ...bundleIdList,
            [parentKey]: newList
        });
    }


    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            if (platform === "IOS" || platform === "macOS") {
                integerList.forEach((element: string) => {
                    res[element] = Number(res[element])
                });
                if (!res.forceDelayedSoftwareUpdates) {
                    delete res.enforcedSoftwareUpdateDelay
                }
                 // 添加Bundle ID列表到提交数据
                Object.keys(bundleIdList).forEach(parentKey => {
                    const bundleIds = bundleIdList[parentKey].filter(id => id && id.trim() !== '');
                    if (bundleIds.length > 0) {
                        res.allowedCameraRestrictionBundleIDs = bundleIds;
                    }
                });
                //console.log(res);
                var selectedSystemPreferenceKeys = [...checkedList, ...checkedList2].filter(item => item.isSelected).map(item => item.key);
                var arg: any = {
                    keys: res,
                    isSystemPreference: openSystemPreferences,
                    selectedSystemPreferenceKeys
                }
                addTemplateRestriction(templateId, arg).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    getDataInfo();
                }, () => {
                    notification.error({ message: t("请求成功") });
                })
            } else {
                for (const key in res) {
                    if (!res[key]) {
                        delete res[key];
                    }
                }   
                if (Object.keys(res).length === 0) {
                    notification.warning({message: t("未选择任何限制")});
                } else {
                    addAndroidTemplateRestriction(templateId, {keys: res}).then(() => {
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    }, () => {
                        notification.error({ message: t("请求成功") });
                    })
                }
            }
        })
    }
    const deleteTemplateClick = () => {
        if (platform === "IOS" || platform === "macOS") {
            deleteTemplateRestriction(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        } else {
            deleteAndroidTemplateRestriction(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        }
    }

    const checkoutRestrict = (e: any) => {
        const enabled = e.target.value;
        setOpenSystemPreferences(enabled);
        if (!enabled) {
            const newData = checkedList.map((item: any) => ({ ...item, isSelected: false }));
            const newData2 = checkedList2.map((item: any) => ({ ...item, isSelected: false }));
            setCheckedList(newData);
            setCheckedList2(newData2);
        }
    }

    const onChange = (e: any, index: number) => {
        const newCheckedList = [...checkedList];
        newCheckedList[index].isSelected = e.target.checked;
        setCheckedList(newCheckedList);
    };

    const onChange2 = (e: any, index: number) => {
        const newCheckedList2 = [...checkedList2];
        newCheckedList2[index].isSelected = e.target.checked;
        setCheckedList2(newCheckedList2);
    };

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("限制")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>{t("设置限制规则")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentRestriction", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>

                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36, marginLeft: 16 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 15 }}
                            initialValues={formValue}
                        >
                            <Collapse defaultActiveKey={['0', '1', '2', '5', '6', '7', '8']} destroyInactivePanel={false}>
                                {(platform === "IOS" || platform === "macOS") && dataInfo?.categoricalRestrictions?.map((cates: any) => (<>
                                    <Collapse.Panel header={t(cates.description)} key={cates.restrictionType}>
                                        {cates.restrictions.map((item: any) => (
                                            <Row key={item.key}>
                                                <Col span={18}>
                                                    <Item label={t(item.name)} name={item.key}>
                                                        { item.valueType === 'boolean' && <Radio.Group defaultValue={item.isAllow} name={item.key} onChange={(e) => {
                                                                if (item.children && item.key === 'forceDelayedSoftwareUpdates') {
                                                                    showDict[item.key] = e.target.value;
                                                                    setShowDict({...showDict});
                                                                    item.children.forEach((child: any) => {
                                                                        if (child.valueType === 'integer' && e.target.value) {
                                                                            formValue[child.key] = child.integerValue;
                                                                            setFormValue({...formValue});
                                                                        }
                                                                    })
                                                                }
                                                                // 处理 allowCamera 的显示逻辑
                                                                 if (item.key === 'allowCamera') {
                                                                    setShowDict({...showDict, [item.key]: e.target.value});
                                                                    console.log(showDict);
                                                                }
                                                            }}>
                                                                <Radio value={true}>{t("是")}</Radio>
                                                                <Radio value={false}>{t("否")}</Radio>
                                                            </Radio.Group>
                                                        }
                                                        { item.key === 'enforcedFingerprintTimeout' && 
                                                            // <Input
                                                            //     addonAfter={t("秒")} 
                                                            //     type="number"
                                                            //     style={{ width: "80%" }} 
                                                            //     min={0}
                                                            // ></Input>
                                                            <Select
                                                                style={{ width: "40%" }} 
                                                            >
                                                                <Select.Option value={0}>不设置</Select.Option>
                                                                <Select.Option value={3600}>1小时</Select.Option>
                                                                <Select.Option value={7200}>2小时</Select.Option>
                                                                <Select.Option value={14400}>4小时</Select.Option>
                                                                <Select.Option value={28800}>8小时</Select.Option>
                                                                <Select.Option value={43200}>12小时</Select.Option>
                                                                <Select.Option value={86400}>24小时</Select.Option>
                                                                <Select.Option value={172800}>48小时</Select.Option>
                                                            </Select>
                                                        }
                                                        { item.key === 'ratingRegion' && 
                                                            <Select
                                                                style={{ width: "40%" }}
                                                                defaultValue={'-1'}
                                                            >
                                                                <Select.Option value={'-1'}>{t("不设置")}</Select.Option>
                                                                <Select.Option value={'us'}>{t("美国")}</Select.Option>
                                                                <Select.Option value={'au'}>{t("澳大利亚")}</Select.Option>
                                                                <Select.Option value={'ca'}>{t("加拿大")}</Select.Option>
                                                                <Select.Option value={'de'}>{t("德国")}</Select.Option>
                                                                <Select.Option value={'fr'}>{t("法国")}</Select.Option>
                                                                <Select.Option value={'ie'}>{t("爱尔兰")}</Select.Option>
                                                                <Select.Option value={'jp'}>{t("日本")}</Select.Option>
                                                                <Select.Option value={'nz'}>{t("新西兰")}</Select.Option>
                                                                <Select.Option value={'gb'}>{t("英国")}</Select.Option>
                                                            </Select>
                                                        }
                                                        { item.key === 'ratingMovies' && 
                                                            <Select
                                                                style={{ width: "40%" }} 
                                                            >
                                                                <Select.Option value={1000}>{t("全部")}</Select.Option>
                                                                <Select.Option value={500}>{t("NC-17")}</Select.Option>
                                                                <Select.Option value={400}>{t("R")}</Select.Option>
                                                                <Select.Option value={300}>{t("PG-13")}</Select.Option>
                                                                <Select.Option value={200}>{t("PG")}</Select.Option>
                                                                <Select.Option value={100}>{t("G")}</Select.Option>
                                                                <Select.Option value={0}>{t("无")}</Select.Option>
                                                            </Select>
                                                        }
                                                        { item.key === 'ratingTVShows' && 
                                                            <Select
                                                                style={{ width: "40%" }} 
                                                            >
                                                                <Select.Option value={1000}>{t("全部")}</Select.Option>
                                                                <Select.Option value={600}>{t("TV-MA")}</Select.Option>
                                                                <Select.Option value={500}>{t("TV-14")}</Select.Option>
                                                                <Select.Option value={400}>{t("TV-PG")}</Select.Option>
                                                                <Select.Option value={300}>{t("TV-G")}</Select.Option>
                                                                <Select.Option value={200}>{t("TV-Y7")}</Select.Option>
                                                                <Select.Option value={100}>{t("TV-Y")}</Select.Option>
                                                                <Select.Option value={0}>{t("无")}</Select.Option>
                                                            </Select>
                                                        }
                                                        { item.key === 'ratingApps' && 
                                                            <Select
                                                                style={{ width: "40%" }} 
                                                            >
                                                                <Select.Option value={1000}>{t("全部")}</Select.Option>
                                                                <Select.Option value={621}>{t("21+")}</Select.Option>
                                                                <Select.Option value={620}>{t("20+")}</Select.Option>
                                                                <Select.Option value={619}>{t("19+")}</Select.Option>
                                                                <Select.Option value={618}>{t("18+")}</Select.Option>
                                                                <Select.Option value={600}>{t("17+")}</Select.Option>
                                                                <Select.Option value={416}>{t("16+")}</Select.Option>
                                                                <Select.Option value={415}>{t("15+")}</Select.Option>
                                                                <Select.Option value={314}>{t("14+")}</Select.Option>
                                                                <Select.Option value={313}>{t("13+")}</Select.Option>
                                                                <Select.Option value={300}>{t("12+")}</Select.Option>
                                                                <Select.Option value={211}>{t("11+")}</Select.Option>
                                                                <Select.Option value={210}>{t("10+")}</Select.Option>
                                                                <Select.Option value={200}>{t("9+")}</Select.Option>
                                                                <Select.Option value={108}>{t("8+")}</Select.Option>
                                                                <Select.Option value={107}>{t("7+")}</Select.Option>
                                                                <Select.Option value={106}>{t("6+")}</Select.Option>
                                                                <Select.Option value={105}>{t("5+")}</Select.Option>
                                                                <Select.Option value={100}>{t("4+")}</Select.Option>
                                                                <Select.Option value={3}>{t("3+")}</Select.Option>
                                                                <Select.Option value={2}>{t("2+")}</Select.Option>
                                                                <Select.Option value={1}>{t("1+")}</Select.Option>
                                                                <Select.Option value={0}>{t("无")}</Select.Option>
                                                            </Select>
                                                        }
                                                    </Item>

                                                </Col>
                                                <Col span={6} style={{ lineHeight: "32px" }}>
                                                    <Tooltip title={
                                                        i18n.language === "zh" ? `只能在${item.minimalOSVersion}以上的设备上才能配置` : 
                                                        i18n.language === "en" ? `Only be configured on devices above iOS ${item.minimalOSVersion}` : ""
                                                    }>
                                                        <Tag color="cyan">{item.minimalOSVersion}</Tag>
                                                    </Tooltip >
                                                    {item.supervisedRequired && (
                                                        <Tooltip title={t("只适用于受监督设备")}>
                                                            <Tag color="purple">S</Tag>
                                                        </Tooltip>
                                                    )}
                                                    {item.isDeprecated && (
                                                        <Tooltip title={t("此功能已废弃、暂时可用，不推荐使用")} >
                                                            <Tag  style={{ background: '#FFF200', color: '#000000' }}>D</Tag>
                                                        </Tooltip>
                                                    )}
                                                </Col>
                                                {item?.children?.map((childTtem: any) => (
                                                    <>
                                                        {item.key !== "forceDelayedSoftwareUpdates" && childTtem.key !== 'allowedCameraRestrictionBundleIDs' && item.valueType === 'boolean' && (
                                                            <>
                                                                <Col span={16} offset={2}>
                                                                    <Item label={t(childTtem.name)} name={childTtem.key}  >
                                                                        <Radio.Group defaultValue={childTtem.isAllow}>
                                                                            <Radio value={true}>{t("是")}</Radio>
                                                                            <Radio value={false}>{t("否")}</Radio>
                                                                        </Radio.Group>
                                                                    </Item>
                                                                </Col>
                                                                <Col span={6} style={{ lineHeight: "32px" }}>
                                                                    <Tooltip title={
                                                                        i18n.language === "zh" ? `只能在${childTtem.minimalOSVersion}以上的设备上才能配置` : 
                                                                        i18n.language === "en" ? `Only be configured on devices above iOS ${childTtem.minimalOSVersion}` : ""
                                                                    }>
                                                                        <Tag color="cyan">{childTtem.minimalOSVersion}</Tag>
                                                                    </Tooltip >
                                                                    {childTtem.supervisedRequired && (
                                                                        <Tooltip title={t("只适用于受监督设备")}>
                                                                            <Tag color="purple">S</Tag>
                                                                        </Tooltip>
                                                                    )}
                                                                    {childTtem.isDeprecated && (
                                                                        <Tooltip title={t("此功能已废弃、暂时可用，不推荐使用")} >
                                                                            <Tag  style={{ background: '#FFF200', color: '#000000' }}>D</Tag>
                                                                        </Tooltip>
                                                                    )}
                                                                </Col>
                                                            </>
                                                        )}
                                                        {showDict[item.key] && item.key === "forceDelayedSoftwareUpdates" && (
                                                            <Col span={16} offset={2}>
                                                                <Item 
                                                                    label={t(childTtem.name)}
                                                                    name={childTtem.key}
                                                                    extra={<><InfoCircleOutlined /> {t("延迟软件升级有效天数")}{childTtem.integerMinValue} {t("到")} {childTtem.integerMaxValue} {t("天")},{t("默认30天")}</>}
                                                                >
                                                                    <Input
                                                                        addonAfter={t("天")} 
                                                                        type="number"
                                                                        style={{ width: "80%" }} 
                                                                        min={childTtem.integerMinValue}
                                                                        max={childTtem.integerMaxValue} 
                                                                    ></Input>
                                                                </Item>
                                                            </Col> 
                                                        )}

                                                        {showDict[item.key] === false && childTtem.key === 'allowedCameraRestrictionBundleIDs' && (
                                                            <><Col span={16} offset={2}>
                                                                <div style={{ textAlign: 'left', marginBottom: 6,marginLeft:'40%' }}>
                                                                    <div style={{ marginBottom: 8 }}>
                                                                        {t(childTtem.name)}:
                                                                    </div>
                                                                    {(bundleIdList[item.key] || []).map((bundleId, idx) => (
                                                                        <Row key={idx} style={{ textAlign:'left', marginBottom: 8 }}>
                                                                            <Col span={20}>
                                                                                <Input
                                                                                    placeholder={t("请输入 Bundle ID")}
                                                                                    value={bundleId}
                                                                                    onChange={(e) => updateBundleId(item.key, idx, e.target.value)}
                                                                                    style={{ width: '100%' }}
                                                                                />
                                                                            </Col>
                                                                            <Col span={4} style={{ textAlign: 'center' }}>
                                                                                <Button 
                                                                                    type="link" 
                                                                                    danger 
                                                                                    onClick={() => removeBundleId(item.key, idx)}
                                                                                    icon={<DeleteOutlined />}
                                                                                >
                                                                                </Button>
                                                                            </Col>
                                                                        </Row>
                                                                    ))}
                                                                    <div style={{ textAlign: 'left' }}>
                                                                        <Button 
                                                                            type="dashed" 
                                                                            onClick={() => addBundleId(item.key)} 
                                                                            block 
                                                                            icon={<PlusOutlined />}
                                                                            style={{ width: 'calc(100% - 0px)' }}
                                                                        >
                                                                            {t("添加")}
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col span={6} style={{ lineHeight: "32px" }}>
                                                                <Tooltip title={
                                                                    i18n.language === "zh" ? `只能在${childTtem.minimalOSVersion}以上的设备上才能配置` : 
                                                                    i18n.language === "en" ? `Only be configured on devices above iOS ${childTtem.minimalOSVersion}` : ""
                                                                }>
                                                                    <Tag color="cyan">{childTtem.minimalOSVersion}</Tag>
                                                                </Tooltip >
                                                                {childTtem.supervisedRequired && (
                                                                    <Tooltip title={t("只适用于受监督设备")}>
                                                                        <Tag color="purple">S</Tag>
                                                                    </Tooltip>
                                                                )}
                                                                {childTtem.isDeprecated && (
                                                                    <Tooltip title={t("此功能已废弃、暂时可用，不推荐使用")} >
                                                                        <Tag  style={{ background: '#FFF200', color: '#000000' }}>D</Tag>
                                                                    </Tooltip>
                                                                )}
                                                            </Col>
                                                            </>
                                                        )}
                                                    </>
                                                ))}
                                            </Row>
                                        ))}
                                    </Collapse.Panel>
                                </>))}
                                {platform == "Android" && dataInfo?.categoricalRestrictions?.map((cates: any) => (<>
                                    <Collapse.Panel header={t(cates.description)} key={cates.restrictionType}>
                                        {
                                            cates.restrictions.map((item: any) => {
                                                return (
                                                    <Row key={item.key}>
                                                        <Col span={18}>
                                                            <Item label={t(item.name)} name={item.key}>
                                                                <Radio.Group name={item.key} style={{display: "flex", flexDirection: item.options.length > 2 ? "column" : "row"}}>
                                                                    {item.options.map((option: any) => {
                                                                        return <Radio value={option}>{t(option)}</Radio>
                                                                    })}
                                                                </Radio.Group>
                                                            </Item>
                                                        </Col>
                                                       
                                                    </Row>
                                                )
                                            })
                                        }
                                    </Collapse.Panel>
                                </>))}
                                {platform === "macOS" && (<>
                                    <Collapse.Panel header={t("系统偏好")} key="7">
                                        <div>
                                            <Row style={{marginBottom: "24px", lineHeight: "32px"}}>
                                                <Col style={{marginRight: "5px"}}>{t("限制系统偏好中的项目")}:</Col>
                                                <Col>
                                                    <Radio.Group defaultValue={openSystemPreferences} onChange={(e) => checkoutRestrict(e)}>
                                                        <Radio value={true}>{t("是")}</Radio>
                                                        <Radio value={false}>{t("否")}</Radio>
                                                    </Radio.Group>
                                                </Col>
                                            </Row>
                                            {openSystemPreferences && <>
                                                <Row style={{marginBottom: "24px", lineHeight: "32px"}}>
                                                    <Col>{t("选中禁用")}</Col>
                                                </Row>
                                                {/* <Row style={{lineHeight: "32px"}}>
                                                    <Checkbox defaultChecked={checkAll} onChange={onCheckAllChange} indeterminate={indeterminate}>
                                                        {t("Check all")}
                                                    </Checkbox>
                                                </Row> */}
                                                <Tabs type="card">
                                                    <Tabs.TabPane tab={<>System Preference<br/>(earlier than macOS 13)</>} key={1}>
                                                        {checkedList.map((item: any, index: number) => {
                                                            if (index % 2 === 0 && index + 1 < checkedList.length) {
                                                                return (<>
                                                                    <Row style={{marginBottom: "24px", lineHeight: "32px"}}>
                                                                        <Col span={12}>
                                                                            <Checkbox checked={checkedList[index].isSelected} onChange={(e) => { onChange(e, index) }}>
                                                                                {item?.name}
                                                                            </Checkbox>
                                                                        </Col>
                                                                        <Col span={12}>
                                                                            <Checkbox checked={checkedList[index+1].isSelected} onChange={(e) => { onChange(e, index + 1) }}>
                                                                                {checkedList[index + 1]?.name}
                                                                            </Checkbox>
                                                                        </Col>
                                                                    </Row>
                                                                </>);
                                                            }
                                                            if (index === checkedList.length - 1 && index % 2 == 0) {
                                                                return (<>
                                                                    <Row style={{marginBottom: "24px", lineHeight: "32px"}}>
                                                                        <Col span={12}>
                                                                            <Checkbox checked={checkedList[index].isSelected} onChange={(e) => { onChange(e, index) }}>
                                                                                {item?.name}
                                                                            </Checkbox>
                                                                        </Col>
                                                                    </Row>
                                                                </>)
                                                            }
                                                        })}
                                                    </Tabs.TabPane>
                                                    <Tabs.TabPane tab={<>System Settings<br />(macOS 13 and higher)</>} key={2}>
                                                        {checkedList2.map((item: any, index: number) => {
                                                            if (index % 2 === 0 && index + 1 < checkedList2.length) {
                                                                return (<>
                                                                    <Row style={{marginBottom: "24px", lineHeight: "32px"}}>
                                                                        <Col span={12}>
                                                                            <Checkbox checked={checkedList2[index].isSelected} onChange={(e) => { onChange2(e, index) }}>
                                                                                {item?.name}
                                                                            </Checkbox>
                                                                        </Col>
                                                                        <Col span={12}>
                                                                            <Checkbox checked={checkedList2[index+1].isSelected} onChange={(e) => { onChange2(e, index + 1) }}>
                                                                                {checkedList2[index + 1]?.name}
                                                                            </Checkbox>
                                                                        </Col>
                                                                    </Row>
                                                                </>);
                                                            }
                                                            if (index === checkedList2.length - 1 && index % 2 == 0) {
                                                                return (<>
                                                                    <Row style={{marginBottom: "24px", lineHeight: "32px"}}>
                                                                        <Col span={12}>
                                                                            <Checkbox checked={checkedList2[index].isSelected} onChange={(e) => { onChange2(e, index) }}>
                                                                                {item?.name}
                                                                            </Checkbox>
                                                                        </Col>
                                                                    </Row>
                                                                </>)
                                                            }
                                                        })}
                                                    </Tabs.TabPane>
                                                </Tabs>
                                            </>}
                                        </div>
                                    </Collapse.Panel>
                                </>)}
                            </Collapse>

                        </Form>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};